import React from 'react';
import styles from './PopupHeader.module.css';

const PopupHeader = (props) => {
    const { title = '', onClose = () => { }, containerStyle = {} } = props;

    return (
        <div className={[styles.heading, containerStyle].join(' ')}>
            <h3>{title}</h3>
            <h3 className={styles.close} onClick={onClose}>X</h3>
        </div>
    );
}

export default PopupHeader;
